import React from 'react';

const Error = () => {
  return (
    <div>
      <h1>This is the Error Page</h1>
    </div>
  );
};

export default Error;
